const exp = {
  newRequest: { id: -2, code: "NEW_REQUEST" },
  restructuring: { id: -3, code: "RESTRUCTURING" },
  cession: { id: -4, code: "CESSION" },
  facilityOffer: { id: -5, code: "OFFER_FACILITY" },
  facilityRisk: { id: -6, code: "RISK_FACILITY" }
};
export default exp;
